import { c as _c } from "react/compiler-runtime";
import { PatientDynamicFieldType } from "@/types/enums";
import PatientHealthFieldDialog from "./patient-health-field-dialog";
const PRESCRIPTIONS_CONFIG = {
  type: PatientDynamicFieldType.PRESCRIPTIONS,
  title: "Prescriptions",
  description: "Add current medications and prescriptions. Information from patient forms will appear here automatically.",
  placeholder: "e.g., Lisinopril 10mg",
  addButtonText: "Add prescription",
  addAnotherButtonText: "Add another prescription"
};
interface PrescriptionsDialogProps {
  children?: React.ReactNode;
  patientId: string;
}
export default function PrescriptionsDialog(t0) {
  const $ = _c(3);
  const {
    children,
    patientId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== patientId) {
    t1 = <PatientHealthFieldDialog config={PRESCRIPTIONS_CONFIG} patientId={patientId}>{children}</PatientHealthFieldDialog>;
    $[0] = children;
    $[1] = patientId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}